import * as React from 'react';
import { ArticleHeading3, ArticleParagraph1, Image, UIText3 } from '@cian/ui-kit';

import * as styles from './PromoCardRedesign.css';

import { PromoCardLabel } from './parts/PromoCardLabel';
import { ISpecialPromo } from '../../types/specialPromos/specialPromos';

interface IMortgagePromoCardProps {
  promo: ISpecialPromo;
  onClick?(): void;
}

export const PromoCardRedesign = React.forwardRef<HTMLDivElement, IMortgagePromoCardProps>(
  ({ promo, onClick }, ref) => {
    return (
      <article
        ref={ref}
        className={styles['card']}
        onClick={onClick}
        role="button"
        tabIndex={0}
        data-testid="PromoItem"
      >
        <div className={styles['top-content']}>
          <div>
            <div className={styles['labels']}>
              {promo.labels.map(({ text, type }) => (
                <PromoCardLabel key={type} text={text} type={type} />
              ))}
            </div>
            <ArticleHeading3 as="h3" data-testid="PromoItemHeading">
              {promo.promoName}
            </ArticleHeading3>
            <div className={styles['provider']}>
              <ArticleParagraph1>{promo.providerName}</ArticleParagraph1>
            </div>
          </div>
          <div className={styles['logo']}>
            <Image
              src={promo.providerLogo}
              height="100%"
              width="100%"
              data-testid="PromoItemProviderLogo"
              objectFit="contain"
            />
          </div>
        </div>
        <ul className={styles['bottom-content']} data-testid="MortgagePromoCardFactoids">
          {promo.promoProps.map((prop, index) => (
            <li className={styles['factoid']} key={index}>
              <UIText3 color="gray60_100">{prop.title}</UIText3>
              <ArticleParagraph1>{prop.value}</ArticleParagraph1>
            </li>
          ))}
        </ul>
      </article>
    );
  },
);

PromoCardRedesign.displayName = 'PromoCardRedesign';
